import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import "./axiosMiddleware"

Vue.use(Vuex);


const store = new Vuex.Store({
    state: {
        requestType: null,
        //API_URL: 'http://localhost:3000', // local
        //API_URL: 'https://imgeneric-api.it-smm.id', // development
        //API_URL: 'https://imengine.sinarmasmining.com', // production gcp
        // API_URL: 'https://imengineprelive.sinarmasmining.com', // staging gcp
        //WE_URL: 'https://we.sinarmasmining.com', // prod we
        WE_URL: 'https://devwe.it-smm.id',
        // WE_URL: 'http://api.we.kom',
        // WE_URL: 'http://127.0.0.1:2999',
        //ISEARCH_URL: 'https://devapi.sinarmasmining.com',
        ISEARCH_URL: 'https://api.sinarmasmining.com',
        //ISEARCH_ADDRESS: 'http://newsearch.sinarmasmining.com',
        ISEARCH_ADDRESS: 'https://isearch.sinarmasmining.com',
        token: localStorage.getItem('token') || '',
        
        refresh_token: localStorage.getItem('refresh_token') || '',
        
        isImGroup: location.host == 'localhost:8080' ? true : false, // local
        // isImGroup: location.host == 'https://imemoprelive.sinarmasmining.com' ? true : false, // dev
        //isImGroup: location.host == 'imemo.sinarmasmining.com' ? true : false, // prod
        adminType: {},
        showDrawer: false,
        loadingData: false,
        userId: 1,
        dataUsers: JSON.parse(localStorage.getItem('user')) || {},
        dataRequests: {data : [], jumlah: 0},
        dataRequestsForex: [],
        dataReqApproval: {data : [], jumlah: 0},
        dataReqApprovalForex: [],
        currentForm: {},
        dataEditRequest: {},
        dataDelivery: [],
        loader: false,
        temp: null,
        dataReport: [],
        dataEntitle: [],
        adminGeneral: [],
        adminForex: [],
        adminEdit: [],
        adminUsers: [],
        userSelected: '',
        dataCompanies: [],
        shortenUrl: '',
        changeManagementNotif: false,
        sharing: {
            title: 'Shared from iMemo System',
            description: 'to save the trees, I would rather to share this digital document than print. \nThanks.',
        },
        networks: [
            { network: 'email', name: 'Email', img: '../assets/gmail.png' },
            { network: 'whatsapp', name: 'Whatsapp', img: '../assets/whatsapp-logo.png' }
        ],
        dataBisnisUnit: [],
        dataApprovalPending: [],
        themeColor: "#fff",
        logo: null,
        logoNoText: null,
        dataReqCC: {data : [], jumlah: 0}
    },
    mutations: {
        setCreateMemoRequestType(state, status) {
            state.requestType = status;
        },
        toggleDrawer(state) {
            state.showDrawer = !state.showDrawer;
        },
        toggleLoading(state) {
            state.loadingData = !state.loadingData;
        },
        changeFormType(state, n) {
            Vue.set(state.currentForm, 'type', n);
        },
        temporaryData(state, n) {
            state.temp = n;
        },
        authSetToken(state, token) {
            state.token = token;
        },
        authClearToken(state) {
            state.token = '';
        },
        authSetRefreshToken(state, refresh_token) {
            state.refresh_token = refresh_token;
        },
        authClearRefreshToken(state) {
            state.refresh_token = '';
        },
        authSetUserData(state, n) {
            state.dataUsers = n;
        },
        authClearUserData(state) {
            state.dataUsers = {};
        },
        setDataReport(state, n) {
            state.dataReport = n;
        },
        toggleChangeManagementNotif(state) {
            state.changeManagementNotif = !state.changeManagementNotif
        },
        dataBisnisUnit(state, n) {
            state.dataBisnisUnit = n;
        },
        setThemeColor(state, n) {
            state.themeColor = n;
        },
        setLogo(state, n) {
            state.logo = n
        },
        setLogoNoText(state, n) {
            state.logoNoText = n
        },
        setDefaultBu(state, n) {
            state.dataUsers.user.default_bu = n
        }
    },
    actions: {
        fetchDataUsers({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/api/users/${state.userId}`).then(res => {
                commit('toggleLoading');
                commit('authSetUserData', res.data);
            });
        },
        fetchDataRequests({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/api/requests?_id=${state.dataUsers._id}`).then(res => {
                commit('toggleLoading');
                state.dataRequests = res.data;
            })
        },
        fetchDataRequestsRefactor({ state, commit }) {
            commit('toggleLoading');
            // let group = state.isImGroup ? 'bcg' : 'nongroup';
            axios.get(process.env.VUE_APP_API_OLD + `/api/requests/refactor?_id=${state.dataUsers.user._id}&query=__&direction=-1&sortBy=imDate&page=1&per_page=10`).then(res => {                
                commit('toggleLoading');
                // state.dataRequests = res.data;
                state.dataRequests = {data : res.data.data, jumlah: res.data.jumlah};
            })
        },

        fetchForexRequests({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/forex?_id=${state.dataUsers._id}`).then(res => {
                commit('toggleLoading');
                state.dataRequestsForex = res.data;
            })
        },
        fetchDataApproval({ state, commit }) {
            commit('toggleLoading');
            axios({
                method: "get",
                url: `${state.API_URL}/api/approval/requests/${state.dataUsers._id}`,
                auth: {
                    username: 'imemo',
                    password: 'Ang3lT3n4n!#'
                }
            }).then(res => {
                commit('toggleLoading');
                state.dataReqApproval = res.data;
            })
        },
        fetchDataApprovalRefactor({ state, commit }) {
            commit('toggleLoading');
            // let group = state.isImGroup ? 'bcg' : 'nongroup';
            axios({
                method: "get",
                url: process.env.VUE_APP_API_OLD + `/api/approval/requests/${state.dataUsers.user._id}/refactor?query=__&direction=-1&sortBy=imDate&page=1&per_page=10`,
                auth: {
                    username: 'imemo',
                    password: 'Ang3lT3n4n!#'
                }
            }).then(res => {
                commit('toggleLoading');
                state.dataReqApproval = { data: res.data.data, jumlah: res.data.jumlah };
            }).catch((e) => {
                console.log(e)
                commit('toggleLoading');
            })
        },

        fetchForexApproval({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/forex/approval/requests/${state.dataUsers._id}`).then(res => {
                commit('toggleLoading');
                state.dataReqApprovalForex = res.data;
            })
        },
        fetchDataEditRequests({ state, commit }, id) {
            commit('toggleLoading');
            let token = localStorage.getItem("token");
            axios({
                method: "get",
                url: process.env.VUE_APP_API_OLD+`/api/requests/${id}`,
                headers: { Authorization: `Bearer ${token}` },
            }).then(res => {
                commit('toggleLoading');
                state.dataEditRequest = res.data[0];
            });
        },
        fetchForexEditRequests({ state, commit }, id) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/forex/requests/${id}`).then(res => {
                commit('toggleLoading');
                state.dataEditRequest = res.data[0];
            });
        },
        fetchDataDelivery({ state, commit }, i18n) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/api/delivery`).then(res => {
                commit('toggleLoading');
                state.dataDelivery = res.data.map(data => ({
                    ...data,
                    cuisTujuanLabel: i18n[data.cuisTujuan]
                }));
            });
        },
        fetchDataReport({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/report/allrequest`).then(res => {
                commit('toggleLoading');
                commit('setDataReport', res.data);
            });
        },
        sendDataDelivery({ state }, { payload, isDelivered }) {
            return axios.put(`${state.API_URL}/api/delivery?isDelivered=${isDelivered}`, payload)
        },
        login({ commit }, creds) { //target
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_API+`/auth/login`, creds).then(resp => {
                    if (resp.data.message) return reject(resp.data.message);
                    let { access_token,refresh_token, user } = resp.data;
                    localStorage.setItem('token', access_token);
                    localStorage.setItem('refresh_token', refresh_token);
                    localStorage.setItem('user', JSON.stringify(user));
                    commit('authSetToken', access_token);
                    commit('authSetUserData', user);
                    resolve(access_token);
                }).catch(err => {
                    reject(err);
                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        otpLogin({ commit }, creds) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_API+`/auth/login-get-otp`, creds).then(resp => {
                    if (resp.data.message) return reject(resp.data.message);
                    console.log("----")
                    console.log(resp)
                    let error = resp.data.error
                    // let { access_token, user } = resp.data;
                    // localStorage.setItem('token', access_token);
                    // localStorage.setItem('user', JSON.stringify(user));
                    // commit('authSetToken', access_token);
                    // commit('authSetUserData', user);
                    resolve({status:true,error});
                }).catch(err => {
                    reject(err);
                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        setTokenByRefresh({commit},creds){
            console.log("ACCESS TOKEN IS RENEWED ")
            localStorage.setItem('token', creds.newToken);
            commit('authSetToken', creds.newToken);
        }
        ,getTokenByRefresh({ commit }, creds) {
            // commit('toggleLoading');
            return new Promise((resolve, reject) => {
                // Fetch public IP address using Axios

                    let refresh = localStorage.getItem('refresh_token');
                    axios.post(`${process.env.VUE_APP_API}/auth/refresh`, {refresh_token:refresh})
                    .then(resp => {
                        if (resp.data.message) {
                            return reject(resp.data.message);
                        }
                        
                        let { access_token,refresh_token, user } = resp.data;
                        localStorage.setItem('token', access_token);
                        localStorage.setItem('refresh_token', refresh_token);
                        localStorage.setItem('user', JSON.stringify(user));
                        localStorage.setItem('login_id', login_id);
                        localStorage.setItem('email_logout', creds.email);

                        commit('authSetToken', access_token);
                        commit('authSetRefreshToken', access_token);
                        commit('authSetUserData', user);
                        resolve(true);
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => {
                        commit('toggleLoading');
                    });
            })
        }

        ,otpVerify({ commit }, creds) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                // Fetch public IP address using Axios
                axios.get('https://api.ipify.org?format=json')
                    .then(response => {
                        const publicIp = response.data.ip;
                        creds.ip = publicIp; // Set the public IP in the creds object
                    })
                    .catch(() => {
                        // If there's an error fetching the IP, set creds.ip to null
                        creds.ip = "-";
                    })
                    .finally(() => {
                        // Make the OTP verification request
                        axios.post(`${process.env.VUE_APP_API}/auth/login-verify-otp`, creds)
                            .then(resp => {
                                if (resp.data.message) {
                                    return reject(resp.data.message);
                                }
        
                                let { access_token, refresh_token, login_id, user } = resp.data;
                                localStorage.setItem('token', access_token);
                                localStorage.setItem('refresh_token', refresh_token);
                                localStorage.setItem('user', JSON.stringify(user));
                                localStorage.setItem('login_id', login_id);
                                localStorage.setItem('email_logout', creds.email);
        
                                commit('authSetRefreshToken', refresh_token);
                                commit('authSetToken', access_token);
                                commit('authSetUserData', user);
                                resolve(true);
                            })
                            .catch(err => {
                                reject(err);
                            })
                            .finally(() => {
                                commit('toggleLoading');
                            });
                    });
            });
        },
        ssoGoogleAuth({ commit }, creds) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                // Fetch public IP address using Axios
                axios.get('https://api.ipify.org?format=json')
                    .then(response => {
                        const publicIp = response.data.ip;
                        creds.ip = publicIp; // Set the public IP in the creds object
                    })
                    .catch(() => {
                        // If there's an error fetching the IP, set creds.ip to null
                        creds.ip = "-";
                    })
                    .finally(() => {
                        // Make the OTP verification request
                        axios.post(`${process.env.VUE_APP_API}/auth/login-sso-google`, creds)
                            .then(resp => {
                                if (resp.data.message) {
                                    return reject(resp.data.message);
                                }
        
                                let { access_token, refresh_token, login_id, user } = resp.data;
                                localStorage.setItem('token', access_token);
                                localStorage.setItem('refresh_token', refresh_token);
                                localStorage.setItem('user', JSON.stringify(user));
                                localStorage.setItem('login_id', login_id);
                                localStorage.setItem('email_logout', user.email);
        
                                commit('authSetRefreshToken', refresh_token);
                                commit('authSetToken', access_token);
                                commit('authSetUserData', user);
                                resolve(true);
                            })
                            .catch(err => {
                                reject(err);
                            })
                            .finally(() => {
                                commit('toggleLoading');
                            });
                    });
            });
        },    
        updateData({ state, commit }, creds) {
            state.loader = true;
            return new Promise((resolve, reject) => {
                // const nik = creds.nik ? creds.nik : creds._id;
                axios.post(`${state.API_URL}/update-data-fiori`, creds, { timeout: 20000 }).then(resp => {
                    // if (resp.data.message) return reject(resp.data.message);
                    let localUser = JSON.parse(localStorage.getItem('user'));
                    // localUser.nik_supervisor = resp.data.SpvNik.toString();
                    if (resp.data.hasOwnProperty('spv')) localUser.organization[0].approver = [resp.data.spv];
                    commit('authClearUserData');
                    localStorage.removeItem('user');
                    localStorage.setItem('user', JSON.stringify(localUser));
                    commit('authSetUserData', localUser);
                    resolve(resp);
                }).catch(err => {
                    state.loader = false;
                    reject(err);
                }).finally(() => {
                    state.loader = false;
                })
            })
        },logout({ state, commit }) {
            let login_id = localStorage.getItem("login_id");
            let email = localStorage.getItem('email_logout');
        
            // Return a promise
            return new Promise((resolve, reject) => {
                if (login_id) {
                    // Fetch public IP address using Axios
                    axios.get('https://api.ipify.org?format=json')
                        .then(response => {
                            const publicIp = response.data.ip;
        
                            // Make the logout request with public IP
                            return axios.post(`${process.env.VUE_APP_API}/auth/logout`, { login_id: login_id, ip: publicIp, email: email });
                        })
                        .catch(() => {
                            // If there's an error fetching the IP, set ip to null and proceed
                            return axios.post(`${process.env.VUE_APP_API}/auth/logout`, { login_id: login_id, ip: "-", email: email });
                        })
                        .then(resp => {
                            if (resp.data.message) {
                                return reject(resp.data.message);
                            }
                            localStorage.removeItem('login_id');
                            resolve(true);
                        })
                        .catch(err => {
                            reject(err);
                        })
                        .finally(() => {
                            resolve(true);
                        });
                }   
                commit('authClearToken');
                commit('authClearUserData');
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('animationTime');
                localStorage.removeItem('animationPointer');
                state.loadingData = false;
                resolve();
            });
        },
        fetchEntitle({ state, commit }) {
            commit('toggleLoading');
            axios({
                method: "get",
                url: `${state.API_URL}/api/entitle`,
                auth: {
                    username: 'imemo',
                    password: 'Ang3lT3n4n!#'
                }
            }).then(res => {
                commit('toggleLoading');
                state.dataEntitle = res.data;
            })
        },
        adminType({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/api/checkAdmin`, {
                params: {
                    userId: state.dataUsers.id
                }
            }).then(res => {
                commit('toggleLoading');
                state.adminType = res.data;
            })
        },
        adminGeneral({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/api/adminGeneral`, {
                params: {
                    userId: state.dataUsers.id
                }
            }).then(res => {
                commit('toggleLoading');
                state.adminGeneral = res.data;
            })
        },
        // getAdminUsers({state,commit}){
        //     commit('toggleLoading');
        //     const config = {
        //         method: "get",
        //         url: `${state.API_URL}/api/bod`,
        //     };
        //     axios(config)
        //         .then(res=>{
        //             commit('toggleLoading');
        //             state.adminUsers = res.data
        //         })
        // },
        adminForex({ state, commit }) {
            commit('toggleLoading');
            axios.get(`${state.API_URL}/api/adminForex`).then(res => {
                commit('toggleLoading');
                state.adminForex = res.data;
            })
        },
        getShortenUrl({ state, commit }, payload) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_API_OLD+`/s/genUrl`,
                    {
                        "imId": payload.im._id,
                        "_id": payload.im.userId,
                        "email": payload.im.imUser.email
                    }
                )
                .then(res => {
                    state.shortenUrl = res.data;
                    resolve(res)
                })
                .catch((err) => {
                    state.shortenUrl = null;
                    reject(err);
                })
                .finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        createDataBu({ commit }, payload) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                let token = localStorage.getItem('token');
                axios.post(process.env.VUE_APP_API+`/business-unit/create`,
                    {
                        "bu_name": payload.name,
                    }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(res => {

                    resolve(res)
                })
                    .catch((err) => {
                        reject(err);
                    })
                    .finally(() => {
                        commit('toggleLoading');
                    })
            })
        },
        createDataUsers({ commit }, payload) {
            
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                let token = localStorage.getItem('token');
                axios.post(process.env.VUE_APP_API+`/users/create`,
                    {
                        "full_name": payload.users.full_name,
                        "email": payload.users.email,
                        "msisdn": payload.users.msisdn? payload.users.msisdn.replaceAll('+', '').replace(/\s/g, '') : null,
                        "is_super_admin": payload.users.is_super_admin,
                        "list_bu": [
                            {
                                "email": payload.bu.email,
                                "msisdn": payload.bu.msisdn? payload.bu.msisdn.replaceAll('+', '').replace(/\s/g, ''): null,
                                "position": payload.bu.position.trim(),
                                "alias": payload.bu.alias,
                                "is_active": payload.bu.is_active,
                                "is_admin": payload.bu.is_admin,
                                "business_unit": {
                                    "id": payload.bu.bisnis_unit
                                }
                            }
                        ]
                    }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(res => {
                    if (res.data.status == 200) resolve(res)
                    else reject(res.data.message);
                }).catch((err) => {
                    reject(err);

                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        createDataSuperAdmin({ commit }, payload) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                let token = localStorage.getItem('token');
                axios.post(process.env.VUE_APP_API+`/users/seed`,
                    {
                        "full_name": payload.users.full_name,
                        "email": payload.users.email,
                        "msisdn": payload.users.msisdn? payload.users.msisdn.replaceAll('+', '').replace(/\s/g, '') : null,
                        "is_super_admin": payload.users.is_super_admin,
                    }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(res => {
                    if (res.data.status == 200) resolve(res)	
                    else reject(res.data.message);
                }).catch(err => {

                    reject(err);

                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        addBisnisUnitToUsers({ commit }, payload) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                let token = localStorage.getItem('token');
                axios.post(process.env.VUE_APP_API+`/business-unit/add/${payload.user_id}`,
                    {
                        "email": payload.bu.email,
                        "msisdn": payload.bu.msisdn? payload.bu.msisdn.replaceAll('+', '').replace(/\s/g, ''): null,
                        "position": payload.bu.position.trim(),
                        "alias": payload.bu.alias,
                        "is_active": true,
                        "is_admin": payload.bu.is_admin,
                        "is_payment_voucher": payload.bu.is_payment_voucher === true,
                        "is_auto_notif_pr": payload.bu.is_auto_notif_pr === true,
                        "business_unit": {
                            "id": payload.bu.bisnis_unit
                        }
                    }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(res => {
                    resolve(res)

                }).catch((err) => {
                    reject(err);

                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        createDataUsersBU({ commit }, payload) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                let token = localStorage.getItem('token');
                axios.post(process.env.VUE_APP_API+`/users/admin/create`,
                    {
                        "full_name": payload.users.full_name,
                        "email": payload.users.email,
                        "msisdn": payload.users.msisdn? payload.users.msisdn.replaceAll('+', '').replace(/\s/g, '') : null,
                        "list_bu": [
                            {
                                "email": payload.bu.email,
                                "msisdn": payload.bu.msisdn ? payload.bu.msisdn.replaceAll('+', '').replace(/\s/g, '') : null,
                                "position": payload.bu.position.trim(),
                                "alias": payload.bu.alias,
                                "is_active": payload.bu.is_active,
                                "is_admin": payload.bu.is_admin,
                                "is_payment_voucher": payload.bu.is_payment_voucher === true,
                                "is_auto_notif_pr": payload.bu.is_auto_notif_pr === true,
                                "business_unit": {
                                    "id": payload.bu.bisnis_unit
                                }
                            }
                        ]
                    }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(res => {
                    if (res.data.status == 200) resolve(res)	
                    else reject(res.data.message);
                }).catch((err) => {
                    reject(err);

                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        ResetPassword({ commit }, payload) {

            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_API+`/reset-password/request`, { "email": payload.email }).then(resp => {
                    if (resp.data.status == 400) return reject(resp.data.message);
                    resolve(resp.data);
                }).catch(err => {
                    reject(err);
                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        VerifiedResetPass({ commit }, payload) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_API+`/reset-password/verified`, { "code": payload.code, "password": payload.confirm_password }).then(resp => {
                    if (resp.data.status == 400) return reject(resp.data.message);
                    resolve(resp.data);
                }).catch(err => {
                    reject(err);
                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        updateDataUsers({ commit }, payload) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                let token = localStorage.getItem('token');
                axios.put(process.env.VUE_APP_API+`/users/profile/${payload.user_id}`,
                    {
                        "full_name": payload.users.full_name,
                        "password_old": payload.users.old_password,
                        "password": payload.users.confirm_password,
                        "msisdn": payload.users.msisdn? payload.users.msisdn.replaceAll('+', '').replace(/\s/g, '') : null,
                        "is_active": payload.users.is_active,
                        "is_super_admin": payload.users.is_super_admin
                    }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(res => {
                    resolve(res)

                }).catch((err) => {
                    reject(err);

                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        updateDataBuToUsers({ commit }, payload) {
            commit('toggleLoading');
            // console.log(payload.bu.is_active === 'active' || true ? true : false)
            return new Promise((resolve, reject) => {
                let token = localStorage.getItem('token');
                const buPayload = {
                    "id": payload.bu_id,
                    "alias": payload.bu.alias,
                    "full_name": payload.bu.full_name? payload.bu.full_name: undefined,
                    "email": payload.bu.email,
                    "msisdn": payload.bu.msisdn? payload.bu.msisdn.replaceAll('+', '').replace(/\s/g, ''): undefined,
                    "position": payload.bu.position.trim(),
                    "is_active": payload.bu.is_active === 'active' || payload.bu.is_active === true ? true : false,
                    "is_admin": payload.bu.is_admin === 'yes' || payload.bu.is_admin === true ? true : false,
                    "default_bu": payload.bu.default_bu_id
                };

                if (payload.bu.is_payment_voucher !== undefined) {
                    buPayload.is_payment_voucher = payload.bu.is_payment_voucher === true;
                }

                if (payload.bu.is_auto_notif_pr !== undefined) {
                    buPayload.is_auto_notif_pr = payload.bu.is_auto_notif_pr === true;
                }

                axios.put(process.env.VUE_APP_API+`/users/bu/${payload.user_id}`,
                    buPayload, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(res => {
                    resolve(res)

                }).catch((err) => {
                    reject(err);

                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        submitApproval({ commit }, payload) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                let token = localStorage.getItem('token');
                axios.post(process.env.VUE_APP_API+`/approval/admin/submit/${payload.id}`,
                    {
                        "approve_type": payload.approval.approve_type,
                        "reason": payload.approval.reason,
                        "need_creator": payload.approval.need_creator
                    }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(res => {
                    resolve(res)

                }).catch((err) => {
                    reject(err);

                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        resendNotif({ commit }, payload) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                let token = localStorage.getItem('token');
                axios.post(process.env.VUE_APP_API_OLD+`/api/requests/send-notif`,
                    {
                        "imNo": payload.imNo,
                    }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(res => {
                    resolve(res)

                }).catch((err) => {
                    reject(err);

                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        updateDataSetting({ commit }, payload) {
            commit('toggleLoading');
            return new Promise((resolve, reject) => {
                let token = localStorage.getItem('token');
                axios.put(process.env.VUE_APP_API+`/business-unit/editSetting/${payload.setting.bu}`,
                    {
                        "themeColors": payload.setting.color,
                        // "emailSender": payload.setting.email,
                        "footerEmailWhatsApp": payload.setting.footer_notif,
                        "reminderApproval": payload.setting.reminder_approval_days,
                        "reminderApprovalHrs": payload.setting.reminder_approval_time,
                        "headerLogo": {
                            "src": payload.preview_logo.url,
                            "srcName": payload.preview_logo.name
                        },
                        "fullApprovedWatermark": {
                            "src": payload.preview_wm_full_approve.url,
                            "align": payload.preview_wm_full_approve.position,
                            "rotate": payload.preview_wm_full_approve.rotate,
                            "size": payload.preview_wm_full_approve.size,
                            "srcName": payload.preview_wm_full_approve.name
                        },
                        "rejectedWatermark": {
                            "src": payload.preview_wm_reject.url,
                            "align": payload.preview_wm_reject.position,
                            "rotate": payload.preview_wm_reject.rotate,
                            "size": payload.preview_wm_reject.size,
                            "srcName": payload.preview_wm_reject.name
                        },
                        "onApprovalWatermark": {
                            "src": payload.preview_wm_on_approval.url,
                            "align": payload.preview_wm_on_approval.position,
                            "rotate": payload.preview_wm_on_approval.rotate,
                            "size": payload.preview_wm_on_approval.size,
                            "srcName": payload.preview_wm_on_approval.name
                        },
                        "withdrawWatermark": {
                            "src": payload.preview_wm_withdraw.url,
                            "align": payload.preview_wm_withdraw.position,
                            "rotate": payload.preview_wm_withdraw.rotate,
                            "size": payload.preview_wm_withdraw.size,
                            "srcName": payload.preview_wm_withdraw.name
                        },
                        "draftWatermark": {
                            "src": payload.preview_wm_draft.url,
                            "align": payload.preview_wm_draft.position,
                            "rotate": payload.preview_wm_draft.rotate,
                            "size": payload.preview_wm_draft.size,
                            "srcName": payload.preview_wm_draft.name
                        },
                        "approvalSignIcon": {
                            "src": payload.preview_icon_approve.url,
                            "srcName": payload.preview_icon_approve.name
                        },
                        "rejectionSignIcon": {
                            "src": payload.preview_icon_reject.url,
                            "srcName": payload.preview_icon_reject.name
                        },
                        "withdrawSignIcon": {
                            "src": payload.preview_icon_withdraw.url,
                            "srcName": payload.preview_icon_withdraw.name
                        },
                    },{
                        headers: { Authorization: `Bearer ${token}` }
                }).then(res => {
                    resolve(res)

                }).catch((err) => {
                    reject(err);

                }).finally(() => {
                    commit('toggleLoading');
                })
            })
        },
        fetchPreviewConfig({ commit }, payload) {
            commit('toggleLoading');
    
            let token = localStorage.getItem("token");
            axios
            .get(
                process.env.VUE_APP_API +
                `/business-unit/detail/${payload.bu_id}`,
                {
                headers: { Authorization: `Bearer ${token}` },
                }
            )
            .then((res) => {
                commit('toggleLoading');

                // commit ('setThemeColor', res.data.settings ? res.data.settings.themeColors ? res.data.settings.themeColors : "#D42A2A" : "#D42A2A")

                commit ('setThemeColor', res.data.settings && res.data.settings.themeColors ? res.data.settings.themeColors : "#D42A2A")

                if ( res.data.hasOwnProperty('settings') && res.data.settings.hasOwnProperty('headerLogo') && res.data.settings.headerLogo.src != null ) {
                    commit('setLogo', res.data.settings.headerLogo.src)
                    commit('setLogoNoText', res.data.settings.headerLogo.src)
                } else {
                    commit('setLogo', require('../assets/imemo-white-text.png'))
                    commit('setLogoNoText', require('../assets/imemo-white.png'))
                }
            })
        },
        fetchDataCC({ state, commit }) {
            commit('toggleLoading');
            let token = localStorage.getItem("token");
            const config = {
                method: "post",
                url: process.env.VUE_APP_API + `/requests/list/cc`,
                headers: {"Authorization": `Bearer ${token}`},
                data: {
                    "sortBy": "imDate",
                    "direction": -1,
                    "page": 1,
                    "perPage": 10,
                    "status": [],
                    "category": [],
                    "keyword": "",
                    "buId": []
                },
            };
            axios(config)
                .then(res => {
                    commit('toggleLoading');
                    state.dataReqCC = {data : res.data.data, jumlah: res.data.total};
                })
        },
    },
    getters: {
        isAuthenticated: state => !!state.token,
        isShowingDrawer: state => state.showDrawer && !!state.token,
        userOrganization: state => state.dataUsers.organization || [],
        userType: state => state.dataUsers || false,
        getThemeColor: state => state.themeColor,
        getLogo: state => state.logo,
        getLogoNoText: state => state.logoNoText,
        getTokenExpiredDate: (state)=> {
            if (!state.token) return true; // If no token, consider it expired
    
            // Assuming the token is a JWT
            const payload = JSON.parse(atob(state.token.split('.')[1])); // Decode the token payload
            return payload.exp// Check if the expiration time is less than the current time
        }
    },

    // plugins:[tokenValidation],
});

export default store;
